import React, { useState, useEffect } from 'react';
import { IoMdClose } from 'react-icons/io';
import { Helmet } from 'react-helmet';

import './contact.scss';

/**
 * Contact Component.
 * It shows the company's contact information.
 * Address
 * Telephone
 * Fax
 * E-mail
 * Table with names and roles
 */
const Contact = () => {

   const [name, setName] = useState('');
   const [email, setEmail] = useState('');
   const [confirmEmail, setConfirmEmail] = useState('');
   const [subject, setSubject] = useState('');
   const [message, setMessage] = useState('');
   const [isAble, setIsAble] = useState(false);
   const [wasEmailSent, setWasEmailSent] = useState(false);

   useEffect(() => {
      
      if ((name && email && confirmEmail && subject && message) && email === confirmEmail) {
         setIsAble(true);
      } else {
         setIsAble(false)
      }
      return () => {
         if (wasEmailSent) {
            setWasEmailSent(false);
         }
      }
   }, [name, email, confirmEmail, subject, message, isAble, wasEmailSent])


   const handleSend = e => {
      e.preventDefault();
      if (name && email && confirmEmail && subject && message && isAble) {

         const template_params = {
            "reply_to": email,
            "subject": subject,
            "from_name": name,
            "message_html": message
         }
         
         const service_id = "default_service";
         const template_id = "template_YZc2juJA";
         window.emailjs.send(service_id, template_id, template_params)
         .then(response => {
            console.log('Success! response status:' + response.status);
            console.log('response text:' + response.text);
            setName('');
            setEmail('');
            setConfirmEmail('');
            setSubject('');
            setMessage('');
            setWasEmailSent(true);
         }, error => {
            console.log('Failed...' + error)
            setWasEmailSent(false);
         });

      }
   }

   const handleCloseConfirmMessage = e => {
      e.preventDefault();
      setWasEmailSent(false);
   }

   return (
      <main className="container-fluid">
         <Helmet>
            <title>Inheritance Publications - Contact Us</title>
            <meta name="keywords" content="books, historical books, reformed books, reformed books for children, fiction books, reformed church, historical fiction, historical fiction books, short stories, liturgy, reformed worship, 80 years war, 30 years war, world war 2, Bible books, Christian books, Christian literature, literature, Psalm CDs, Hymn CDs, DVDs, Music DVDs, audio books, sheet music, church sheet music, Dutch sheet music, Psalm sheet music, organ sheet music"/>
            <meta name="description" content="Inheritance Publications is a small company which was established to provide Biblical Reformed literature. We want to maintain the antithesis between right and wrong, between true and false christianity. It is also our desire to give God the honour and glory due to His Name because of His faithfulness. Remembering the great deeds of God in the history of His Church will always cause God's children to stand in awe of His Majesty. It is our aim to reach children, young adults, and adults with stories about the history of the Church. We also provide a wide selection of books on the doctrine of the Church. May God's Name be glorified and the readers edified by the reading of our books."/>
         </Helmet>
         <div className="row align-items-center about-us-heading contact-heading">
            <div className="about-us-shadow">
               <h1>Contact</h1>
            </div>
         </div>

         <div className="row justify-content-around p-3 p-md-5">
            <div className="">
               <h2>Inheritance Publications</h2>
               <p className="contact-family-name">The Janssen Family</p>

               <p>Postal address (Canada & International & U.S. Wholesale Orders):</p>
               <p>3317 Township Rd 624</p>
               <p>Neerlandia (County of Barrhead), Alberta</p>
               <p>T0G 1R1 Canada</p>
               <p>Tel: 780-674-3949</p>
               <p>Fax: 780-674-3949</p>
               <p style={{marginBottom: 0}}>E-Mail: orders@inhpubl.net</p>
            </div>

            <div className="message-us">
               <div className="table d-flex justify-content-center">
                  <table className="contact-table">
                     <tbody>
                        <tr>
                           <td>President</td><td>Mr. Roelof A. Janssen - <a href="mailto:roelof@inhpubl.net">roelof@inhpubl.net</a></td>
                        </tr>
                        <tr>
                           <td>Editor</td><td>Mrs. Theresa Janssen</td>
                        </tr>
                        <tr>
                           <td>Developer / assistant</td><td>Bruno Lima</td>
                        </tr>
                     </tbody>
                  </table>
               </div>

               <div className="contact-form p-1 p-xs-3 p-lg-5">
                  <form className="d-flex flex-column p-4">

                     {wasEmailSent ?
                        <div className="send-confirmation d-flex justify-content-center align-items-center text-center">
                           <span onClick={e => handleCloseConfirmMessage(e)}><IoMdClose /></span>
                           <div>Thank you! Your message was sent.</div>
                        </div>
                        : null
                     }

                     <h2 className="h3 text-center">Send us a message!</h2>
                     {(email && confirmEmail) && email !== confirmEmail ?
                        <div className="email-error">
                           <p>The email is not the same on both fields</p>
                        </div> :
                        null
                     }
                     {/* <div className="name-email d-flex justify-content-between"> */}
                        <input 
                           type="text" 
                           placeholder="Name" 
                           value={name} 
                           onChange={(e) => setName(e.target.value)}/>
                        <input type="text" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}/>
                        <input type="text" placeholder="Confirm email" value={confirmEmail} onChange={(e) => setConfirmEmail(e.target.value)}/>
                     {/* </div> */}
                     <input 
                        className="w-100" 
                        type="text" 
                        placeholder="Subject" 
                        value={subject} 
                        onChange={(e) => setSubject(e.target.value)}/>
                     <textarea 
                        className="w-100" 
                        placeholder="Message" 
                        value={message} 
                        onChange={(e) => setMessage(e.target.value)}></textarea>
                     {isAble ?
                        <button 
                        className="btn btn-info w-25" 
                        type="submit" 
                        value="Send" 
                        onClick={(e) => handleSend(e)}>Send</button> :
                        <button 
                        className="btn btn-info w-25" 
                        type="submit" 
                        value="Send"
                        disabled 
                        onClick={(e) => handleSend(e)}>Send</button>
                     }
                  </form>
               </div>
            </div>
         </div>
      </main>
   )
}

export default Contact;